import React, { useState } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

export default function ImageAndThumbnails(props) {
    const { product } = props
    const { childrenFile, thumbnails } = product
    const [index, setIndex] = useState(0)
    if (!childrenFile.length) return
    return (
        <>
            {/* SELECTED IMAGE */}
            <div className={`position-relative${thumbnails.length > 1 ? '' : ' mb-5'}`}>
                <GatsbyImage image={getImage(childrenFile[index])} alt='' />
            </div>

            {/* THUMBNAILS */}
            {
                thumbnails.length > 1 &&
                <Stack direction='horizontal' gap={2} className='overflow-auto pt-4'>
                        {thumbnails.map((file, i) => {
                        return (
                            <Button key={`thumbnail-${i}`} variant='' className='p-0 border-0' onClick={() => setIndex(i)}>
                                <GatsbyImage
                                    image={getImage(file)}
                                    alt=''
                                    className={`flex-shrink-0 ${i === index ? 'border border-primary shadow' : ''}`}
                                />
                            </Button>
                        )
                    })}
                </Stack>
            }
        </>
    )
}